import styled from "styled-components";

export const PurchaseUnderReviewContainer = styled.main`
  font-family: ${({ theme }) => theme.typography.fontFamily.primary};
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 2rem;
  display: flex;
  width: 100%;

  .textTitle {
    font-weight: 700;
    font-size: 1.25rem;
    line-height: 1.5rem;
    color: #460259;
  }

  .successfulPurchase {
    font-weight: 600;
    font-size: 1.25rem;
    line-height: 1.5rem;
    color: #ffac33;
    display: flex;
    justify-content: start;
  }

  .threeDots {
    margin-left: 0.6rem;
  }

  .processedPurchase {
    font-weight: 300;
    font-size: 0.875rem;
    margin-top: 1rem;
    margin-bottom: 1rem;
    color: rgba(67, 67, 67, 0.75);
  }
`;

export const PurchaseUnderReviewContent = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;

  .contentItems {
    display: flex;
    flex-direction: column;
    border: 2px solid #ffac33;
    border-radius: 5px;
    padding: 1.5rem;
    padding: 1rem;
    height: 100%;
    width: 100%;
  }

  .transactionComplete {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    padding: 1rem;
  }
`;

export const Products = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 1rem;
  width: 100%;
  gap: 2rem;

  @media (max-width: 425px) {
    align-items: center;

    h2 {
      text-align: center;
    }
  }

  span {
    font-size: 0.75rem;
    margin-left: 0.75rem;
    color: #6bbfbf;
  }
`;
